// styles/Login.styles.js
import theme from './../../theme';

const LoginStyles = {
  container: {
    minHeight: '100vh',
    backgroundColor: theme.colors.black,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  paper: {
    padding: '40px',
    maxWidth: '400px',
    backgroundColor: theme.colors.extraLightGray,
    borderRadius: '12px',
    boxShadow: theme.shadows.medium,
  },

  /* --- ADDED: simple logo style --- */
  logo: {
    height: 130,
    width: 'auto',
    marginBottom: '12px',
    display: 'block',
  },
  /* -------------------------------- */

  avatar: {
    margin: '10px',
    backgroundColor: theme.colors.black,
  },
  form: {
    marginTop: '24px',
    width: '100%',
  },
  textField: {
    marginBottom: '16px',
  },
  loginButton: {
    marginTop: '16px',
    marginBottom: '16px',
    backgroundColor: theme.colors.green,
    color: theme.colors.white,
    '&:hover': {
      backgroundColor: theme.colors.greenHover || '#6aa832',
    },
  },
  registerText: {
    marginTop: '16px',
    color: theme.colors.mediumGray,
    textAlign: 'center',
  },
  registerLink: {
    color: theme.colors.green,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default LoginStyles;
